import React, { FC } from "react";
import { useEmployeeChangeLog } from "./hooks/useEmployeeChangeLog";
import useRequestHeaders from "hooks/useRequestHeaders";
import Card from "components/base/Card";
import IconLoading from "components/icons/IconLoading";
import ErrorMessage from "components/base/ErrorMessage";
import { useLanguage } from "contexts/LanguageContext";
import { EmployeeChangeLogChanges } from "./EmployeeChangeLogChanges";

interface Props {
  employeeUPN: string;
}

export const EmployeeChangeLog: FC<Props> = ({ employeeUPN }) => {
  const headers = useRequestHeaders();
  const { messages } = useLanguage();

  const { changeLog, isLoading, isError } = useEmployeeChangeLog(
    String(employeeUPN),
    headers
  );

  let content;
  if (isLoading) {
    content = (
      <div className="flex-col-items-content-center mt-32">
        <IconLoading />
      </div>
    );
  } else if (isError) {
    content = (
      <div className="flex-col-items-content-center">
        <ErrorMessage message={messages.fetchEmployeeChangeLog.content} />
      </div>
    );
  } else {
    content =
      changeLog && changeLog.length ? (
        <EmployeeChangeLogChanges
          changeLog={changeLog}
        ></EmployeeChangeLogChanges>
      ) : (
        <div className="p-24">
          <p className="text-center">{messages.emptyChangeLog}</p>
        </div>
      );
  }

  return (
    <Card className="employee-change-log">
      <div className="header">
        <h2>{messages.changeLog}</h2>
      </div>

      {content}
    </Card>
  );
};
